import utils from '@/utils';

export default {
  login: ({ state, commit }, { email, password, callback }) => {
    utils.send({
      path: '/auth/login',
      options: {
        email: email,
        password: password,
      },
      callback(data) {
        commit('login', data);
        callback(data);
      },
    });
  },

  logout: ({ state, commit }) => {
    utils.send({
      path: '/auth/logout',
      callback() {
        commit('logout');
      },
    });
  },

  updateClear: ({ state, commit }) => {
    commit('updateClear');
  },

  update: ({ state, commit }, { form, callback }) => {
    utils.send({
      path: '/auth/update',
      options: {
        old_password: form.old_password,
        new_password: form.new_password,
      },
      callback(data) {
        utils.success('authUpdate');
        callback(data);
      },
    });
  },

  forgotClear: ({ state, commit }) => {
    commit('forgotClear');
  },

  forgot: ({ state, commit }, { form, callback }) => {
    utils.send({
      path: '/auth/code',
      options: {
        email: form.email,
      },
      callback(data) {
        utils.success('authForgot');
        callback(data);
      },
    });
  },

  registLoad: ({ state, commit }, { email, code }) => {
    commit('registLoad', { email, code });
  },

  registClear: ({ state, commit }) => {
    commit('registClear');
  },

  regist: ({ state, commit }, { form, callback }) => {
    utils.send({
      path: '/auth/regist',
      options: {
        email: form.email,
        code: form.code,
        password: form.password,
      },
      callback(data) {
        utils.success('authRegist');
        callback(data);
      },
    });
  },
};
